import { i18n } from '@lt/localization';
import type { SortType } from './types';

// По возрастанию
export const ORDER_ASC = 'asc';
// По убыванию
export const ORDER_DESC = 'desc';

// Типы сортировок для search/explore
export const SORT_TYPES: SortType[] = [
  {
    label: i18n.t('search.sorting.relevance.label'),
    id: 'relevance',
    types: [
      {
        label: i18n.t('search.sorting.relevance.show'),
        order: null,
      },
    ],
  },
  {
    id: 'price',
    label: i18n.t('search.sorting.price.label'),
    types: [
      {
        label: i18n.t('search.sorting.price.cheap'),
        order: ORDER_ASC,
      },
      {
        label: i18n.t('search.sorting.price.expensive'),
        order: ORDER_DESC,
      },
    ],
  },
  {
    id: 'rating',
    label: i18n.t('search.sorting.rating.label'),
    types: [
      {
        label: i18n.t('search.sorting.rating.show'),
        order: ORDER_DESC,
      },
    ],
  },
];

// Типы сортировок для отзывов
export const SORT_TYPES_REVIEWS: SortType[] = [
  {
    label: i18n.t('hotel.reviews.sorting.date.label'),
    id: 'date',
    types: [
      {
        label: i18n.t('hotel.reviews.sorting.date.new'),
        order: ORDER_DESC,
      },
      {
        label: i18n.t('hotel.reviews.sorting.date.old'),
        order: ORDER_ASC,
      },
    ],
  },
  {
    label: i18n.t('hotel.reviews.sorting.rating.label'),
    id: 'rating',
    types: [
      {
        label: i18n.t('hotel.reviews.sorting.rating.positive'),
        order: ORDER_DESC,
      },
      {
        label: i18n.t('hotel.reviews.sorting.rating.negative'),
        order: ORDER_ASC,
      },
    ],
  },
];
